var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getPlastic as getPlasticAction } from '../../actions/plastic/creators';
import axios from 'axios';
import PlasticItem from './PlasticItem';
import Loader from '../../components/Loader';
import { Link } from 'react-router-dom';
var Cards = /** @class */ (function (_super) {
    __extends(Cards, _super);
    function Cards() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            deleteError: false,
            loading: false
        };
        _this.plasticDelete = function (id) {
            var that = _this;
            var gamblerId = _this.props.user.gamblerId;
            var data = {
                'GamblerId': gamblerId,
                'CardId': id
            };
            _this.setState({
                loading: true,
                deleteError: false
            });
            axios.post("/plastic/delete", data)
                .then(function (res) {
                if (res.data.Code) {
                    _this.setState({
                        deleteError: true,
                        loading: false,
                    });
                }
                else {
                    that.props.getPlasticAction(gamblerId);
                    _this.setState({
                        loading: false,
                    });
                }
            })
                .catch(function (e) {
                _this.setState({
                    deleteError: true,
                    loading: false
                });
            });
        };
        _this.onSubmit = function () {
            _this.setState({
                loading: true
            });
            var data = {
                'SuccessUrl': "".concat(window.origin, "/add-card/success"),
                'GamblerId': _this.props.user.gamblerId
            };
            axios.post("/plastic/add", data)
                .then(function (res) {
                if (res.data.Code === -1) {
                    _this.setState({
                        loading: false
                    });
                }
                else if (res.data.BackUrl) {
                    window.location.href = res.data.BackUrl;
                }
            })
                .catch(function (e) {
                _this.setState({
                    loading: false
                });
            });
        };
        return _this;
    }
    Cards.prototype.componentDidMount = function () {
        this.props.getPlasticAction(this.props.user.gamblerId);
    };
    Cards.prototype.renderSuccess = function () {
        return (_jsx("div", __assign({ className: 'block blc_history blc_info history' }, { children: _jsxs("div", __assign({ className: 'add-cards-page__success' }, { children: ["\u041A\u0430\u0440\u0442\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u0440\u0438\u0432\u044F\u0437\u0430\u043D\u0430 \u00A0", _jsx(Link, __assign({ to: '/withdraw', style: { color: '#025A34', fontWeight: 'bold' } }, { children: "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u0441\u043D\u044F\u0442\u0438\u0435" }))] })) })));
    };
    Cards.prototype.render = function () {
        var _this = this;
        var withdraw = this.props.withdraw;
        var _a = this.state, deleteError = _a.deleteError, loading = _a.loading;
        var plastics = withdraw.get('plastics');
        if (plastics === undefined) {
            return false;
        }
        var renderer = document.location.href.includes('success') ?
            this.renderSuccess() :
            (_jsxs("div", __assign({ className: 'block blc_history blc_info history' }, { children: [_jsx("div", __assign({ className: 'add-cards-page' }, { children: _jsxs("div", __assign({ className: 'add-cards-page__description' }, { children: [deleteError &&
                                    _jsx("div", __assign({ className: 'add-cards-page__description__error' }, { children: "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430! \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435" })), plastics.length > 0
                                    ? _jsx("div", __assign({ className: 'plastic-items' }, { children: plastics.map(function (plastic) {
                                            return _jsx(PlasticItem, { plastic: plastic, plasticDelete: _this.plasticDelete }, plastic.Id);
                                        }) }))
                                    : _jsx("strong", { children: "\u0421\u043F\u0438\u0441\u043E\u043A \u043F\u0443\u0441\u0442" })] })) })), _jsx("div", __assign({ className: 'add-card__form' }, { children: _jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ onClick: this.onSubmit }, { children: "\u041F\u0440\u0438\u0432\u044F\u0437\u0430\u0442\u044C \u043A\u0430\u0440\u0442\u0443" })) })) }))] })));
        return (_jsxs("div", __assign({ id: 'content' }, { children: [loading && _jsx(Loader, {}), _jsxs("div", __assign({ className: 'backward' }, { children: [_jsx("div", { className: 'back', onClick: this.props.history.goBack, style: { marginBottom: 0 } }), _jsx("div", __assign({ className: 'header' }, { children: _jsx("div", __assign({ className: 'title' }, { children: "\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0435 \u043A\u0430\u0440\u0442\u044B" })) }))] })), renderer] })));
    };
    return Cards;
}(Component));
Cards.propTypes = {
    getPlasticAction: PropTypes.func.isRequired
};
var mapStateToProps = function (state) { return ({
    withdraw: state.withdraw,
    user: state.auth.user,
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getPlasticAction: getPlasticAction
}, dispatch); };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Cards));



// WEBPACK FOOTER //
// ./src/components/cards/index.js